const KEY = 'mana.redirect_after_login'

/**
 * Remember where to send the user after a successful login. Persisted to
 * sessionStorage (not React Router location.state) because OIDC login performs
 * a full browser redirect to an external IdP and back — location.state is lost
 * across that round trip, sessionStorage is not.
 */
export function setPostLoginRedirect(target: string): void {
  try {
    sessionStorage.setItem(KEY, target)
  } catch {
    /* sessionStorage unavailable (e.g. disabled); login still proceeds to / */
  }
}

/**
 * Return the remembered target (defaulting to "/") and clear it. Only same-origin
 * absolute paths are returned; anything else falls back to "/" as a safety measure.
 */
export function consumePostLoginRedirect(): string {
  let target: string | null = null
  try {
    target = sessionStorage.getItem(KEY)
    if (target) sessionStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
  return target && target.startsWith('/') && !target.startsWith('//') ? target : '/'
}
